import { BACKING_DESCRIPTION_HI_LOFT_RPET } from "../../FiltersBar/contants/backing_description";

export const PRODUCT_LIST_PAGE = 21;
export const DEFAULT_ORDER_BY_VALUE = "name";

export const getReferencesOnlyEurope = (patterns) => {
  return patterns.edges.filter((item) => {
    return item.node.business === "EUROPE";
  });
}

export const isHiLoftRpetParameter = (params = []) => {
  if (params.find((param) => param === BACKING_DESCRIPTION_HI_LOFT_RPET)) {
    const backingParams = params.filter((param) => param !== BACKING_DESCRIPTION_HI_LOFT_RPET);
    return {  
      params: backingParams,
      isHiLoftRpet: true
    }
  }
  return {
    params: params,
    isHiLoftRpet: false
  }
}